import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import WhatsAppIcon from "../icons";
import { useLang } from "../../i18n";
import { useContent } from "../../lib/useContent";
import { Reveal } from "../Reveal";

export default function ContactStrip() {
  const { t, pick, lang } = useLang();
  const c = useContent();
  return (
    <section data-testid="contact-strip" className="py-24 bg-ngo-mint/60 grain relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Reveal>
              <p className="text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase text-ngo-leaf mb-4">{t("nav.contact")}</p>
            </Reveal>
            <Reveal i={1}>
              <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-ngo-ink leading-tight">
                {pick({ hi: "हमसे संपर्क करें", en: "Get in Touch" })}
              </h2>
            </Reveal>
            <Reveal i={2}>
              <div className="mt-7 space-y-4 text-ngo-ink/75">
                <p className="flex items-start gap-3">
                  <MapPin size={19} className="mt-1 shrink-0 text-ngo-deep" />
                  <span data-testid="contact-strip-address">{lang === "hi" ? c.address_hi : c.address_en}</span>
                </p>
                <p className="flex items-center gap-3">
                  <Phone size={19} className="shrink-0 text-ngo-deep" />
                  <a href={`tel:${c.phone.replace(/\s/g, "")}`} className="hover:text-ngo-deep transition-colors duration-200">{c.phone}</a>
                </p>
                <p className="flex items-center gap-3">
                  <Mail size={19} className="shrink-0 text-ngo-deep" />
                  <a href={`mailto:${c.email}`} className="hover:text-ngo-deep transition-colors duration-200 break-all">{c.email}</a>
                </p>
              </div>
            </Reveal>
            <Reveal i={3} className="mt-8 flex flex-wrap gap-3">
              <a
                data-testid="strip-whatsapp-btn"
                href={`https://wa.me/${c.social.whatsapp || "919452529739"}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] text-white font-semibold text-sm hover:-translate-y-0.5 transition-transform duration-300"
              >
                <WhatsAppIcon size={17} /> {t("common.whatsapp")}
              </a>
              <a
                data-testid="strip-call-btn"
                href={`tel:${c.phone.replace(/\s/g, "")}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-ngo-deep text-white font-semibold text-sm hover:bg-ngo-forest hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
              >
                <Phone size={16} /> {t("common.callNow")}
              </a>
              <Link
                to="/contact"
                data-testid="strip-contact-btn"
                className="group inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-ngo-deep text-ngo-deep font-semibold text-sm hover:bg-ngo-deep hover:text-white transition-colors duration-300"
              >
                {pick({ hi: "संदेश भेजें", en: "Send a Message" })}
                <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
              </Link>
            </Reveal>
          </div>
          <Reveal i={2}>
            <div data-testid="map-placeholder" className="rounded-[2rem] overflow-hidden border border-ngo-deep/10 shadow-[0_20px_60px_rgba(23,107,58,0.12)] bg-white">
              <iframe
                title="अंशा वेलफेयर सोसाइटी कार्यालय स्थान"
                src="https://www.google.com/maps?q=Raipur,+Pindra,+Varanasi,+Uttar+Pradesh+221201&output=embed"
                className="w-full h-80 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <p className="px-5 py-3.5 text-xs text-ngo-ink/60 bg-ngo-cream">
                {pick({ hi: "25, रायपुर, तहसील पिंडरा, जिला- वाराणसी, उत्तर प्रदेश – 221201", en: "25, Raipur, Tehsil Pindra, District Varanasi, Uttar Pradesh – 221201" })}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
